import React, { useEffect } from 'react';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import useGet from '../../helpers/hooks/useGet';
import { useState } from 'react';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import usePost from '../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
const AdvisorNew = (props) => {
  const history = useHistory();
  const [districts, , districtsLoading] = useGet('/districts', true);
  const [languages, , languagesLoading] = useGet('/languages', true);
  const [expertise, , expertiseLoading] = useGet('/advisory-expertises', true);
  const [vegetables, , vegetablesLoading] = useGet('/vegetables', true);
  const [postAdvisory, postedData, postingError, dataPosting] = usePost(
    '/advisories'
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedExpertise, setSelectedExpertise] = useState([]);
  const [selectedVegetables, setSelectedVegetables] = useState([]);
  const [selectedImage, setSelectedImage] = useState();
  const handleFormSubmit = (event, errors, values) => {
    if (dataPosting) {
      return;
    }
    if (
      errors.length > 0 ||
      selectedDistricts.length === 0 ||
      selectedLanguages.length === 0 ||
      selectedExpertise.length === 0 ||
      selectedVegetables.length === 0
    ) {
      return toastr.warning('Please fix errors in the form');
    }

    if (!selectedImage) {
      return toastr.warning('Please select profile image');
    }
    upload([selectedImage]).then((_urls) => {
      console.log(_urls);
      const obj = {
        ...values,
        languageIds: selectedLanguages.map((x) => x.value),
        expertiseIds: selectedExpertise.map((x) => x.value),
        districtIds: selectedDistricts.map((x) => x.value),
        vegetableIds: selectedVegetables.map((x) => x.value),
        image: _urls[0],
      };
      postAdvisory(obj);
    });
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Advisor has been created successfully');
      history.push('/users/advisors');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Add New Advisor</h4>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>Name</Label>
                      <AvField
                        name='name'
                        placeholder='Name'
                        type='text'
                        errorMessage='Enter Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='name'
                      />
                    </FormGroup>
                    <FormGroup>
                      <div className='custom-file'>
                        <CustomInput
                          type='file'
                          className='custom-file-input'
                          id='image'
                          accept='image/*'
                          onChange={(e) => {
                            setSelectedImage(e.target.files[0]);
                          }}
                        />
                        <Label className='custom-file-label' htmlFor='image'>
                          {selectedImage
                            ? selectedImage.name
                            : 'Choose Profile Picture'}
                        </Label>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor='phone'>Phone</Label>
                      <AvField
                        name='phone'
                        placeholder='Phone (923xxxxxxxxxx)'
                        type='text'
                        errorMessage='Enter Phone in (923xxxxxxxxxx)'
                        className='form-control'
                        validate={{
                          required: { value: true },
                          pattern: { value: '^923' },
                          minLength: { value: 12 },
                          maxLength: { value: 12 },
                        }}
                        id='name'
                      />
                    </FormGroup>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Districts</Label>
                          <Select
                            isLoading={districtsLoading}
                            value={selectedDistricts}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={(e) => setSelectedDistricts(e)}
                            options={
                              districts &&
                              districts.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Languages</Label>
                          <Select
                            isLoading={languagesLoading}
                            value={selectedLanguages}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={(e) => setSelectedLanguages(e)}
                            options={
                              languages &&
                              languages.map((x) => ({
                                value: x.id,
                                label: x.title,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Crops</Label>
                          <Select
                            isLoading={vegetablesLoading}
                            value={selectedVegetables}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={(e) => setSelectedVegetables(e)}
                            options={
                              vegetables &&
                              vegetables.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Problems Expertise</Label>
                          <Select
                            isLoading={expertiseLoading}
                            value={selectedExpertise}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={(e) => setSelectedExpertise(e)}
                            options={
                              expertise &&
                              expertise.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='border mb-3 mt-2'></div>
                    <FormGroup>
                      <Label htmlFor='password'>Set Password</Label>
                      <AvField
                        name='password'
                        placeholder='Password'
                        type='text'
                        errorMessage='Minimun length required is 5'
                        className='form-control'
                        validate={{
                          required: { value: true },
                          minLength: { value: 5 },
                        }}
                        id='password'
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Save Advisor'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default AdvisorNew;
